import React, { useEffect, useState } from 'react';
import { FaTimes } from 'react-icons/fa';
import { useNavigate } from 'react-router-dom';

const CartSidebar = ({ isOpen, onClose, updateCartCount, forceUpdateProducts }) => {
  const [cartItems, setCartItems] = useState([]);
  const navigate = useNavigate();

  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = 'hidden';
      loadCartItems();
    } else {
      document.body.style.overflow = '';
    }

    return () => {
      document.body.style.overflow = '';
    };
  }, [isOpen]);

  const loadCartItems = () => {
    const items = JSON.parse(localStorage.getItem('cartItems')) || [];
    setCartItems(items);
    updateCartCount(items.length); // Update cart count here
  };

  const removeItem = (index) => {
    const newCartItems = [...cartItems];
    newCartItems.splice(index, 1);
    setCartItems(newCartItems);
    localStorage.setItem('cartItems', JSON.stringify(newCartItems));
    updateCartCount(newCartItems.length); // Update cart count
    forceUpdateProducts();
  };

  const calculateSubtotal = () => {
    // Check if all items in the cart have the same orderType
    const hasLargeBox = cartItems.every(item => item.orderType === 'Large Box');
    const hasSmallBox = cartItems.every(item => item.orderType === 'Small Box');

    if (hasLargeBox) {
      return { label: 'Large Box Subscription', total: '99.00' };
    }

    if (hasSmallBox) {
      return { label: 'Small Box Subscription', total: '59.00' };
    }

    // Regular subtotal calculation for mixed or no orderType
    const regularSubtotal = cartItems.reduce((acc, item) => {
      return acc + parseFloat(item.price.replace('$', '')) * item.quantity;
    }, 0).toFixed(2);

    return { label: 'Subtotal', total: regularSubtotal };
  };

  const { label, total } = calculateSubtotal();

  return (
    <div
      className={`fixed top-0 right-0 w-[350px] max-sm:w-full bg-white shadow-lg h-full z-50 transform transition-transform duration-300 ${
        isOpen ? 'translate-x-0' : 'translate-x-full'
      }`}
    >
      <div className="flex flex-col h-full">
        <div className="flex justify-between px-3 pt-3 border-b-2">
          <h2 className="text-xl font-bold mb-4">Shopping Cart</h2>
          <button className="text-[#154F16] text-2xl mb-4" onClick={onClose}>
            <FaTimes />
          </button>
        </div>

        <div className="flex-1 overflow-y-auto">
          {cartItems.length > 0 ? (
            <ul>
              {cartItems.map((item, index) => (
                <li key={index} className="mb-4 flex items-center border-b-2 p-3">
                  <img src={item.img} alt={item.name} className="h-16 w-16 object-cover rounded-lg mr-4" />
                  <div className="flex-1">
                    <p className="font-semibold text-[#154F16]">{item.name}</p>
                    <p>{item.quantity} × ${parseFloat(item.price.replace('$', '')).toLocaleString('en-US', { minimumFractionDigits: 2 })}</p>
                  </div>
                  <button className="text-gray-300 text-sm" onClick={() => removeItem(index)}>
                    <FaTimes />
                  </button>
                </li>
              ))}
            </ul>
          ) : (
            <div className="flex items-center justify-center h-full">
              <p className="text-gray-500">Cart is empty</p>
            </div>
          )}
        </div>

        <div className="border-t pt-4 p-3">
          {cartItems.length > 0 && (
            <>
              <div className="flex justify-between mb-4">
                <p className="font-bold">{label}:</p>
                <p>${parseFloat(total).toLocaleString('en-US', { minimumFractionDigits: 2 })}</p>
              </div>
              <div className="flex flex-col space-y-2">
                <button
                  className="bg-[#F2E7DB] text-black py-2 rounded"
                  onClick={() => {
                    onClose();
                    navigate('/cartlist');
                  }}
                >
                  View Cart
                </button>
                <button onClick={onClose} className="bg-[#154F16] text-white py-2 rounded">Continue Shopping</button>
              </div>
            </>
          )}
        </div>
      </div>
    </div>
  );
};

export default CartSidebar;